const baseURL = "https://med.marriottpharmaceutical.com/";

exports.config = {

    baseUrl: baseURL,

}